import { AxiosError } from 'axios';
import { createBrowserRouter, redirect, LoaderFunctionArgs, Navigate } from "react-router-dom";
import getFacility from '@/features/facility/shared/api/getFacility';
import Consent from '@/features/facility/consent/routes/Consent';
import Welcome from "@/features/facility/welcome/routes/Welcome";
import Top from "@/features/facility/top/routes/Top";
import Registration from '@/features/facility/registration/routes/Registration';
import checkAccessContact from '@/features/facility/contact/api/checkAccessContact';
import ContactMail from '@/features/facility/contact/routes/ContactMail';
import Contact from '@/features/facility/contact/routes/Contact';
import ForgotPassowrd from '@/features/facility/forgotPassword/routes/ForgotPassowrd';
import ResetPassowrd from '@/features/facility/forgotPassword/routes/ResetPassowrd';
import Stock from '@/features/facility/stock/routes/Stock';
import LensIndex from '@/features/facility/orders/routes/LensIndex';
import {default as OrderHistoryIndex} from '@/features/facility/orders/routes/order_history/Index';
import {default as OrderHistoryDetail} from '@/features/facility/orders/routes/order_history/Detail';
import CommercialLens from '@/features/facility/orders/routes/CommercialLens';
import CommercialLensConfirm from '@/features/facility/orders/routes/CommercialLensConfirm';
import CommercialLensComplete from '@/features/facility/orders/routes/CommercialLensComplete';
import TrialLens from '@/features/facility/orders/routes/TrialLens';
import TrialLensConfirm from '@/features/facility/orders/routes/TrialLensConfirm';
import TrialLensComplete from '@/features/facility/orders/routes/TrialLensComplete';
import FlatRateLens from '@/features/facility/orders/routes/FlatRateLens';
import FlatRateLensConfirm from '@/features/facility/orders/routes/FlatRateLensConfirm';
import FlatRateLensComplete from '@/features/facility/orders/routes/FlatRateLensComplete';
import FacilityLens from '@/features/facility/orders/routes/FacilityLens';
import FacilityLensConfirm from '@/features/facility/orders/routes/FacilityLensConfirm';
import FacilityLensComplete from '@/features/facility/orders/routes/FacilityLensComplete';
import PromoCare from '@/features/facility/orders/routes/PromoCare';
import PromoCareConfirm from '@/features/facility/orders/routes/PromoCareConfirm';
import PromoCareComplete from '@/features/facility/orders/routes/PromoCareComplete';
import FlatRateIndex from '../features/facility/flatRates/routes/FlatRateIndex';
import { default as FlatRateRegistration } from '../features/facility/flatRates/routes/Registration';
import { default as FlatRateRegistrationConfirm } from '../features/facility/flatRates/routes/RegistrationConfirm';
import { default as FlatRateRegistrationComplete } from '../features/facility/flatRates/routes/RegistrationComplete';
import Customers from '@/features/facility/flatRates/routes/Customers';
import Customer from '@/features/facility/flatRates/routes/Customer';
import CustomerConfirm from '@/features/facility/flatRates/routes/CustomerConfirm';
import CustomerComplete from '@/features/facility/flatRates/routes/CustomerComplete';
import TerminateCancels from '@/features/facility/flatRates/routes/TerminateCancels';
import Cancel from '@/features/facility/flatRates/routes/Cancel';
import CancelConfirm from '@/features/facility/flatRates/routes/CancelConfirm';
import CancelComplete from '@/features/facility/flatRates/routes/CancelComplete';
import Terminate from '@/features/facility/flatRates/routes/Terminate';
import TerminateConfirm from '@/features/facility/flatRates/routes/TerminateConfirm';
import TerminateComplete from '@/features/facility/flatRates/routes/TerminateCreate';
import LostNonWarranty from '@/features/facility/flatRates/routes/LostNonWarranty';
import LostNonWarrantyNew from '@/features/facility/flatRates/routes/LostNonWarrantyNew';
import LostNonWarrantyConfirm from '@/features/facility/flatRates/routes/LostNonWarrantyConfirm';
import LostNonWarrantyComplete from '@/features/facility/flatRates/routes/LostNonWarrantyComplete';
import FacilityAgreementIndex from '@/features/facility/facilityAgreements/routes/FacilityAgreementIndex';
import FacilityCustomers from '@/features/facility/facilityAgreements/routes/Customers';
import FacilityCustomer from '@/features/facility/facilityAgreements/routes/Customer';
import FacilityCustomerConfirm from '@/features/facility/facilityAgreements/routes/CustomerConfirm';
import FacilityCustomerComplete from '@/features/facility/facilityAgreements/routes/CustomerComplete';
import { default as FacilityTerminateCancels } from '@/features/facility/facilityAgreements/routes/TerminateCancels';
import { default as FacilityCancel } from '@/features/facility/facilityAgreements/routes/Cancel';
import { default as FacilityCancelConfirm } from '@/features/facility/facilityAgreements/routes/CancelConfirm';
import { default as FacilityCancelComplete } from '@/features/facility/facilityAgreements/routes/CancelComplete';
import { default as FacilityTerminate } from '@/features/facility/facilityAgreements/routes/Terminate';
import { default as FacilityTerminateConfirm } from '@/features/facility/facilityAgreements/routes/TerminateConfirm';
import { default as FacilityTerminateComplete } from '@/features/facility/facilityAgreements/routes/TerminateCreate';
import FacilityLostNonWarranty from '@/features/facility/facilityAgreements/routes/LostNonWarranty';
import FacilityLostNonWarrantyNew from '@/features/facility/facilityAgreements/routes/LostNonWarrantyNew';
import FacilityLostNonWarrantyConfirm from '@/features/facility/facilityAgreements/routes/LostNonWarrantyConfirm';
import FacilityLostNonWarrantyComplete from '@/features/facility/facilityAgreements/routes/LostNonWarrantyComplete';
import Confirm from '@/features/facility/confirm/routes/Confirm';
import CompanyOverview from '@/features/facility/baseInformation/routes/CompanyOverview';
import TermsOfUse from '@/features/facility/baseInformation/routes/TermsOfUse';
import PrivacyPolicy from '@/features/facility/baseInformation/routes/PrivacyPolicy';
import ChangeMail from '@/features/facility/change_mail/routes/ChangeMail';

import getCustomer from '@/features/customer/shared/api/getCustomer';
import SignIn from '@/features/customer/auth/routes/SignIn';
import CustomerForgotPassowrd from '@/features/customer/forgotPassword/routes/ForgotPassowrd';
import CustomerResetPassowrd from '@/features/customer/forgotPassword/routes/ResetPassowrd';
import { default as CustomerTop } from '@/features/customer/top/routes/Top';
import { default as CustomerFlatRateRegistration } from '../features/customer/flatRates/routes/Registration';
import { default as CustomerFlatRateRegistrationConfirm } from '../features/customer/flatRates/routes/RegistrationConfirm';
import { default as CustomerFlatRateRegistrationComplete } from '../features/customer/flatRates/routes/RegistrationComplete';
import ChangePlanRequestConfirm from '@/features/customer/flatRates/routes/ChangePlanRequestConfirm';
import ChangePlanRequestComplete from '@/features/customer/flatRates/routes/ChangePlanRequestComplete';
import CancelRequestConfirm from '@/features/customer/flatRates/routes/CancelRequestConfirm';
import CancelRequestComplete from '@/features/customer/flatRates/routes/CancelRequestComplete';
import TerminateRequestConfirm from '@/features/customer/flatRates/routes/TerminateRequestConfirm';
import TerminateRequestComplete from '@/features/customer/flatRates/routes/TerminateRequestComplete';
import LostNonWarrantyRequestConfirm from '@/features/customer/flatRates/routes/LostNonWarrantyRequestConfirm';
import LostNonWarrantyRequestComplete from '@/features/customer/flatRates/routes/LostNonWarrantyRequestComplete';
import { FlatRateProvider } from '../features/customer/shared/providers/FlatRateProvider';
import CustomerCompanyOverview from '@/features/customer/baseInformation/routes/CompanyOverview';
import CustomerTermsOfUse from '@/features/customer/baseInformation/routes/TermsOfUse';
import CustomerPrivacyPolicy from '@/features/customer/baseInformation/routes/PrivacyPolicy';
import EditInfo from '@/features/customer/editInfo/routes/EditInfo';
import EditInfoConfirm from '@/features/customer/editInfo/routes/EditInfoConfirm';
import EditInfoComplete from '@/features/customer/editInfo/routes/EditInfoComplete';

import NotFound from '../template/NotFound';
import CustNotFound from '@/template/CustNotFound';
import getWelcome from '@/features/facility/welcome/api/getWelcome';
const authenticatedFacilityLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const pathName = url.pathname;
  try {
    const response =  await getFacility();
    const facility = response?.data?.facility;

    if (facility?.isFirstLogin) {
      if (pathName !== '/facility/registration' && pathName !== '/facility/welcome') {
        return redirect('/facility/registration');
      }
    } else {
      if (pathName === '/facility/registration') {
        return redirect('/facility/top');
      }
    }
  } catch(error: unknown) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      return redirect('/facility');
    } else {
      return redirect('/facility/welcome');
    }
  }
  return true;
};

const authenticatedFacilityWelcomeLoader = async ({ request }: LoaderFunctionArgs) => {
  try {
    await getWelcome();
  } catch(error: unknown) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      console.error(error.message);
      return redirect('/facility');
    }
  }
  return true;
};

const authenticatedCustomerLoader = async ({ request }: LoaderFunctionArgs) => {
  try {
    await getCustomer();
  } catch(error: unknown) {
    if (error instanceof AxiosError) {
      console.error(error.message);
    }
    return redirect('/customer/sign_in');
  }
  return true;
};

const accessContactLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const token = String(url.pathname.split('/').pop());

  try {
    await checkAccessContact(token);
  } catch(err: any) {
    if (err.data.status === 404) {
      throw new Response("Not Found", { status: 404 });
    }
  }

  return true;
}

const resetPasswordLoader = async ({ request }: LoaderFunctionArgs) => {
  const params = new URLSearchParams(request.url);
  const reset_password = params.get('reset_password');

  if (reset_password !== 'true') {
    throw new Response("Not Found", { status: 404 });
  }

  return true;
}
const promoCareGuardLoader = async ({ request }: LoaderFunctionArgs) => {
  const response = await getFacility();
  const facility = response.data.facility;
  if (!facility?.isPromoCare) {
    return redirect('/facility/top');
  }
  return true;
};

const mainRouter = createBrowserRouter([
  { path: "/", element: <Navigate to="/facility/top" replace /> },
  { path: "/facility", element: <Consent /> },
  { path: "/facility/welcome", element: <Welcome />, loader: authenticatedFacilityWelcomeLoader },
  { path: "/facility/top", element: <Top />, loader: authenticatedFacilityLoader },
  { path: "/facility/registration", element: <Registration />, loader: authenticatedFacilityLoader },
  { path: "/facility/contact_mail", element: <ContactMail /> },
  { path: "/facility/contact", element: <Contact />, loader: authenticatedFacilityLoader },
  { path: "/facility/contact/:token", element: <Contact />, errorElement: <NotFound />, loader: accessContactLoader },
  { path: "/facility/forgot_password", element: <ForgotPassowrd /> },
  { path: "/facility/reset_password", element: <ResetPassowrd />, errorElement: <NotFound />, loader: resetPasswordLoader },
  { path: "/facility/change_mail", element: (<ChangeMail />), loader: authenticatedFacilityLoader},
  { path: "/facility/stock", element: (<Stock />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/index", element: (<LensIndex />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/history", element: (<OrderHistoryIndex />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/history/:id", element: (<OrderHistoryDetail />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/commercial_lens", element: (<CommercialLens />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/commercial_lens/confirm", element: (<CommercialLensConfirm />),loader: authenticatedFacilityLoader},
  { path: "/facility/orders/commercial_lens/complete", element: <CommercialLensComplete />, loader: authenticatedFacilityLoader },
  { path: "/facility/orders/trial_lens", element: (<TrialLens />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/trial_lens/confirm", element: (<TrialLensConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/trial_lens/complete", element: (<TrialLensComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/flat_rate_lens", element: (<FlatRateLens />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/flat_rate_lens/confirm", element: (<FlatRateLensConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/flat_rate_lens/complete", element: (<FlatRateLensComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/orders/facility_lens", element: <FacilityLens />, loader: authenticatedFacilityLoader},
  { path: "/facility/orders/facility_lens/confirm", element: <FacilityLensConfirm />, loader: authenticatedFacilityLoader},
  { path: "/facility/orders/facility_lens/complete", element: <FacilityLensComplete />, loader: authenticatedFacilityLoader},
  {
    path: "/facility/orders/promo_care",
    element: <PromoCare />,
    loader: async (args) => {
      await authenticatedFacilityLoader(args);
      return promoCareGuardLoader(args);
    }
  },
  {
    path: "/facility/orders/promo_care/confirm",
    element: <PromoCareConfirm />,
    loader: async (args) => {
      await authenticatedFacilityLoader(args);
      return promoCareGuardLoader(args);
    }
  },
  {
    path: "/facility/orders/promo_care/complete",
    element: <PromoCareComplete />,
    loader: async (args) => {
      await authenticatedFacilityLoader(args);
      return promoCareGuardLoader(args);
    }
  },
  { path: "/facility/change_mail", element: (<ChangeMail />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/index", element: (<FlatRateIndex />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/registration", element: (<FlatRateRegistration />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/registration/confirm", element: (<FlatRateRegistrationConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/registration/complete", element: (<FlatRateRegistrationComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/customers", element: (<Customers />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/customers/:custCode", element: (<Customer />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/customers/:custCode/confirm", element: (<CustomerConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/customers/:custCode/complete", element: (<CustomerComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/terminate_cancels", element: (<TerminateCancels />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/terminate_cancels/:custCode/cancel", element: (<Cancel />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/terminate_cancels/:custCode/cancel/confirm", element: (<CancelConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/terminate_cancels/:custCode/cancel/complete", element: (<CancelComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/terminate_cancels/:custCode/terminate", element: (<Terminate />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/terminate_cancels/:custCode/terminate/confirm", element: (<TerminateConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/terminate_cancels/:custCode/terminate/complete", element: (<TerminateComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/lost_non_warranty", element: (<LostNonWarranty />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/lost_non_warranty/new", element: (<LostNonWarrantyNew />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/lost_non_warranty/confirm", element: (<LostNonWarrantyConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/flat_rates/lost_non_warranty/complete", element: (<LostNonWarrantyComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/index", element: (<FacilityAgreementIndex />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/customers", element: (<FacilityCustomers />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/customers/:custCode", element: (<FacilityCustomer />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/customers/:custCode/confirm", element: (<FacilityCustomerConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/customers/:custCode/complete", element: (<FacilityCustomerComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/terminate_cancels", element: (<FacilityTerminateCancels />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/terminate_cancels/:custCode/cancel", element: (<FacilityCancel />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/terminate_cancels/:custCode/cancel/confirm", element: (<FacilityCancelConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/terminate_cancels/:custCode/cancel/complete", element: (<FacilityCancelComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/terminate_cancels/:custCode/terminate", element: (<FacilityTerminate />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/terminate_cancels/:custCode/terminate/confirm", element: (<FacilityTerminateConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/terminate_cancels/:custCode/terminate/complete", element: (<FacilityTerminateComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/lost_non_warranty", element: (<FacilityLostNonWarranty />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/lost_non_warranty/new", element: (<FacilityLostNonWarrantyNew />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/lost_non_warranty/confirm", element: (<FacilityLostNonWarrantyConfirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/facility_agreements/lost_non_warranty/complete", element: (<FacilityLostNonWarrantyComplete />), loader: authenticatedFacilityLoader},
  { path: "/facility/confirm", element: (<Confirm />), loader: authenticatedFacilityLoader},
  { path: "/facility/company_overview", element: <CompanyOverview />},
  { path: "/facility/terms_of_use", element: <TermsOfUse />},
  { path: "/facility/privacy_policy", element: <PrivacyPolicy />},

  { path: "/customer/sign_in", element: <SignIn /> },
  { path: "/customer/top", element: <CustomerTop />, loader: authenticatedCustomerLoader },
  { path: "/customer/flat_rates/registration", element: (<FlatRateProvider><CustomerFlatRateRegistration /></FlatRateProvider>), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/registration/confirm", element: (<FlatRateProvider><CustomerFlatRateRegistrationConfirm /></FlatRateProvider>), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/registration/complete", element: (<CustomerFlatRateRegistrationComplete />), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/change_plan_request/confirm", element: (<ChangePlanRequestConfirm />), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/change_plan_request/complete", element: (<ChangePlanRequestComplete />), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/cancel_request/confirm", element: (<CancelRequestConfirm />), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/cancel_request/complete", element: (<CancelRequestComplete />), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/terminate_request/confirm", element: (<TerminateRequestConfirm />), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/terminate_request/complete", element: (<TerminateRequestComplete />), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/lost_non_warranty_request/confirm", element: (<LostNonWarrantyRequestConfirm />), loader: authenticatedCustomerLoader},
  { path: "/customer/flat_rates/lost_non_warranty_request/complete", element: (<LostNonWarrantyRequestComplete />), loader: authenticatedCustomerLoader},
  { path: "/customer/forgot_password", element: <CustomerForgotPassowrd /> },
  { path: "/customer/reset_password", element: <CustomerResetPassowrd />, errorElement: <NotFound />, loader: resetPasswordLoader },
  { path: "/customer/company_overview", element: (<CustomerCompanyOverview />), loader: authenticatedCustomerLoader},
  { path: "/customer/terms_of_use", element: (<CustomerTermsOfUse />), loader: authenticatedCustomerLoader},
  { path: "/customer/privacy_policy", element: (<CustomerPrivacyPolicy />), loader: authenticatedCustomerLoader},
  { path: "/customer/edit_info", element: (<FlatRateProvider><EditInfo /></FlatRateProvider>), loader: authenticatedCustomerLoader},
  { path: "/customer/edit_info/confirm", element: (<FlatRateProvider><EditInfoConfirm /></FlatRateProvider>), loader: authenticatedCustomerLoader},
  { path: "/customer/edit_info/complete", element: (<EditInfoComplete />), loader: authenticatedCustomerLoader},

  { path: "/facility/*", element: <NotFound /> },
  { path: "/customer/*", element: <CustNotFound /> },
  { path: "*", element: <NotFound /> },
]);

export default mainRouter;